/* eslint-disable no-template-curly-in-string */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { loadTowItems } from '../../actions';
import PropTypes from 'prop-types';
import { Modal, Button, message, Table } from 'antd';
import InputField from '../../components/global/InputField';
import PlugwrapThickness from '../../components/PlugwrapThickness'; 
import Calculations from '../../calculations';
import randomcolor from 'randomcolor';
import { CustomModelGraph } from '../../components/custom-model-graph';
import Translation from '../../Translation';
import './ModelAnalyzer.css';
import { utils } from '../../config';


class ModelAnalyzer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            length: 102,
            plugwrapThicknessVal: 0.042,
            lotNumberVal: '', // to be removed
            preferences: this.props.preferences,
            towItems: this.props.itemData,
            visibleplugwrap: false,
            isPropsData: false,
            height: 300,
            isCarbonLoaded: false,
            loadItemsClick: false,
            toFilterTowItemData: {},
            lines: [],
            langSwitch: false
        }

        this.circumferences = [24.45, 24.6, 24.35, 24.1, 23, 22.75, 22.5, 21.15, 20.9, 20.65, 19.25, 19, 18.75, 17.05, 16.8, 16.55];

        this.stringSort = (a, b) => {
            if (a < b) { return -1; }
            if (a > b) { return 1; }
            return 0;
        }

        this.columns = [
            {
                title: <Translation labelName="lbl_circumference" defaultText="Circumference"/>,
                dataIndex: 'itmcirc',
                key: 'itmcirc',
                align: 'left',
                render: this.circRenderer,
                sorter: (a,b) => this.stringSort(a['itmcirc'], b['itmcirc'])
            },
            {
                title: <Translation labelName="tbl_hdr_minimum" defaultText="Minimum"/>,
                children: [
                    {
                        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'minwt',
                        key: 'minwt', 
                        sorter: (a, b) => this.stringSort(a['minwt'], b['minwt'])
                    },
                    {
                        title: <Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'minpd',
                        key: 'minpd',
                        sorter: (a, b) => this.stringSort(a['minpd'], b['minpd'])
                    }
                ]
            },
            {
                title: <Translation labelName="tbl_hdr_maximum" defaultText="Maximum"/>,
                children: [
                    {
                        title: <Translation labelName="lbl_hdr_weight" defaultText="Weight"/>,
                        dataIndex: 'maxwt',
                        key: 'maxwt',
                        sorter: (a, b) => this.stringSort(a['maxwt'], b['maxwt'])
                    },
                    {
                        title: <Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop"/>,
                        dataIndex: 'maxpd',
                        key: 'maxpd',
                        sorter: (a, b) => this.stringSort(a['maxpd'], b['maxpd'])
                    }
                ]
            }
        ];
    }

    circRenderer = (val, row) => {
        return (
            <div>
                <span className="color-block" style={{backgroundColor:row.color}}></span>
                <span>{val}</span>
            </div>
        );
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            });
            if (this.state.preferences && this.state.preferences.language !== nextProps.preferences.language) {
                setTimeout(() => {
                    this.setState({
                        langSwitch: !this.state.langSwitch
                    });
                }, 1000);
            }
        }
    }

    componentWillMount() {
        this.assignData(this.props);
    }

    handleChange(e) {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /**
     * handlePlugwrapCancel closes the plugwrap window
     *
     * @memberof TowItemSelectionForm
     */
    handlePlugwrapCancel = () => {
        this.setState({
            visibleplugwrap: false
        });
    }

    /**
     * showPlugwrapModal displays the plugwrap window
     *
     * @memberof TowItemSelectionForm
     */
    showPlugwrapModal = () => {
        this.setState({
            visibleplugwrap: true
        });
    }

    /**
     * updatePlugwrapValue fills the input field with the plugwrap data selected 
     * from thw plugwrap window
     *
     * @param {*} data
     * @memberof TowItemSelectionForm
     */
    updatePlugwrapValue = (data) => {
        this.setState({
            plugwrapThicknessVal: data
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys },()=>{
            this.renderChart(selectedRows);
        });
    };

    onRowsSelected = (e) => {
        if (this.state.isPropsData && e.length) {
            this.setState({
                lotNumberVal: e[e.length - 1].itemlot
            });
        }
        var lines = [];

        var minwt = 1000;
        var maxwt = 0;
        var minpd = 1000;
        var maxpd = 0;
        var data = e[0];
        var wtPad = 0;
        var pdPad = 0;
        var wtPref = this.state.preferences.weight;
        var pdPref = this.state.preferences.lowpdlim;

        switch (wtPref) {
            case 2:
                wtPad = 50;
                break;
            case 3:
                wtPad = 0.05;
                break;
            default:
                wtPad = 5
        }

        switch (pdPref) {
            case 2:
                pdPad = 500;
                break;
            default:
                pdPad = 50
        }

        if (!data) {
            this.setState({
                lines: []
            });
            return;
        }

        let title = [];
        title.push(this.state.length + 'mm x ' + this.state.circumference + 'mm');
        title.push(this.state.pref.rodmaker[this.state.preferences.rodMaker]);
        if (this.state.isPaperGlue) {
            title.push(this.state.pgWeight + ' ' + this.state.pref.weight[this.state.preferences.weight - 1].replace(/\(|\)/gi, '') + utils.getTranslationText('form_lbl_pw+glue_weight', 'PW+Glue Weight'));
        }
        title.push(this.state.plugwrapThicknessVal + 'mm ' + utils.getTranslationText('lbl_plugwrap_thickness', 'Plugwrap Thickness'));
        title.push(this.state.plasticizer + '% ' + utils.getTranslationText('lbl_plasticizer', 'Plasticizer'));

        this.setState({
            chartTitle: title.join('\n'),
            xAxisTitle: this.state.isPaperGlue ? utils.getTranslationText('lbl_total_weight', 'Total Weight') : utils.getTranslationText('lbl_tow_weight', 'Tow Only Weight') + " "
        });

        if (this.state.isCarbonLoaded) {
            //white filter

            lines.push({
                color: '#B35751',
                title: data.itemlot,
                lineData: [
                    {
                        'x': parseFloat(data.minwt.normal.toFixed(2)),
                        'y': parseFloat(data.minpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.normal.toFixed(2)),
                        'y': parseFloat(data.maxpd.normal.toFixed(2))
                    }
                ]
            });

            //carbon filter
            lines.push({
                color: '#4472C4',
                title: data.itemlot + ' (carbon)',
                lineData: [
                    {
                        'x': parseFloat(data.minwt.carbon.toFixed(2)),
                        'y': parseFloat(data.minpd.carbon.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.carbon.toFixed(2)),
                        'y': parseFloat(data.maxpd.carbon.toFixed(2))
                    }
                ]
            });

            //target filter
            lines.push({
                color: '#A1B966',
                title: data.itemlot + ' (target)',
                lineData: [
                    {
                        'x': parseFloat(data.tgtwt.normal.toFixed(2)),
                        'y': parseFloat(data.tgtpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.tgtwt.carbon.toFixed(2)),
                        'y': parseFloat(data.tgtpd.carbon.toFixed(2))
                    }
                ]
            });

            minwt = lines[0].lineData[0].x;
            maxwt = lines[0].lineData[1].x;
            minpd = lines[0].lineData[0].y;
            maxpd = lines[0].lineData[1].y;

            lines.map(item => {
                let ldata = item.lineData;
                if (ldata[0].x !== 0 && ldata[0].y !== 0) {
                    minwt = Math.min(minwt, ldata[0].x);
                    minpd = Math.min(minpd, ldata[0].y);
                }
                if (ldata[1].x !== 0 && ldata[1].y !== 0) {
                    maxwt = Math.max(maxwt, ldata[1].x);
                    maxpd = Math.max(maxpd, ldata[1].y);
                }

                return true;
            })

            this.setState({
                lines: lines,
                gminwt: minwt - wtPad,
                gmaxwt: maxwt + wtPad,
                gminpd: this.round50(minpd, true) - pdPad,
                gmaxpd: this.round50(maxpd) + pdPad
            });
            return;
        }


        for (var a in e) {
            let data = e[a];
            if (minwt === 0) {
                minwt = data.minwt.normal;
            }
            if (maxwt === 0) {
                maxwt = data.maxwt.normal;
            }
            if (minpd === 0) {
                minpd = data.minpd.normal;
            }
            if (maxpd === 0) {
                maxpd = data.maxpd.normal;
            }

            minwt = Math.min(minwt, data.minwt.normal);
            maxwt = Math.max(maxwt, data.maxwt.normal);
            minpd = Math.min(minpd, data.minpd.normal);
            maxpd = Math.max(maxpd, data.maxpd.normal);

            lines.push({
                color: data.color,
                title: data.itemlot,
                target: [
                    {
                        x: minwt,
                        y: data.tgtpd.normal
                    },
                    {
                        x: maxwt,
                        y: data.tgtpd.normal
                    }
                ],
                lineData: [
                    {
                        'x': parseFloat(data.minwt.normal.toFixed(2)),
                        'y': parseFloat(data.minpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.normal.toFixed(2)),
                        'y': parseFloat(data.maxpd.normal.toFixed(2))
                    }
                ]
            }
            )
        }


        this.setState({
            lines: lines,
            gminwt: minwt - wtPad,
            gmaxwt: maxwt + wtPad,
            gminpd: this.round50(minpd, true) - pdPad,
            gmaxpd: this.round50(maxpd) + pdPad
        });
    }

    renderChart(finalData) {
        let lines = [];
        let minwt = 1000;
        let maxwt = 0;
        let minpd = 1000;
        let maxpd = 0;
        var pdPad = 100;

        this.setState({
            lines: []
        });

        for (var key in finalData) {
            let data = finalData[key];
            if (minwt === 0) {
                minwt = data.minwt;
            }
            if (maxwt === 0) {
                maxwt = data.maxwt;
            }
            if (minpd === 0) {
                minpd = data.minpd;
            }
            if (maxpd === 0) {
                maxpd = data.maxpd;
            }

            minwt = Math.min(minwt, data.minwt);
            maxwt = Math.max(maxwt, data.maxwt);
            minpd = Math.min(minpd, data.minpd);
            maxpd = Math.max(maxpd, data.maxpd);

            lines.push({
                color: data.color,
                title: data.itemlot,
                itmcirc: data.itmcirc,
                stdcirc: data.stdcirc,
                lineData: [
                    {
                        'x': parseFloat(data.minwt.toFixed(2)),
                        'y': parseFloat(data.minpd.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.toFixed(2)),
                        'y': parseFloat(data.maxpd.toFixed(2))
                    }
                ]
            })
        }

        this.setState({
            lines: lines,
            gminwt: this.round2(minwt, true),
            gmaxwt: this.round2(maxwt),
            gminpd: this.round50(minpd, true) - pdPad,
            gmaxpd: this.round50(maxpd) + pdPad
        });
    }

    round2(x, isFloor) {
        return isFloor ? Math.floor(x / 2) * 2 : Math.ceil(x / 2) * 2;
    }

    round50(x, isFloor) {
        return isFloor ? Math.floor(x / 50) * 50 : Math.ceil(x / 50) * 50;
    }
    
    round5(x, isFloor) {
        if (x < 1) {
            return x;
        }
        return isFloor ? Math.floor(x / 5) * 5 : Math.ceil(x / 5) * 5;
    }

    prepareData(finals) {
        var newFinals = [];
        var towItem;

        for (var towKey in finals) {
            towItem = finals[towKey];
            newFinals.push({
                itemlot: towItem.itemlot,
                item: towItem.item,
                lot: towItem.lot,
                itmcirc: towItem.tipcirc,
                stdcirc: towItem.stdcirc,
                plant: towItem.plantcode,
                status: towItem.status,
                color: randomcolor({
                    luminosity: 'bright',
                    hue:'random',
                    format: 'rgb'
                }),
                nomtd: parseFloat(towItem.nomtd.toFixed(2)),
                minwt: parseFloat(towItem.gphminwt.toFixed(2)),
                maxwt: parseFloat(towItem.gphmaxwt.toFixed(2)),
                minpd:parseFloat(towItem.gphminpd.toFixed(2)),
                maxpd: parseFloat(towItem.gphmaxpd.toFixed(2))
            });
        }
        return newFinals;

    }

    findTowItem = (lot) => {
        let towItem = this.state.towItems.find((item) => {
            return item.lot === lot
         });
         return towItem;
    }


    renderTowItemsByCircumference = (towItem) => {
        this.setState({
            rows: []
        });
        let circumferences = this.circumferences;
        let tempTowItem;
        let final= [];
        let input = {
            rodlen: parseFloat(this.state.length),
            pwthick: parseFloat(this.state.plugwrapThicknessVal)
        }
        towItem.stdcirc = towItem.itmcirc;
        let preferences = Object.assign({}, this.state.preferences);
        preferences.transportJet = 3;
        let calculations = Calculations(preferences);
        circumferences.forEach((circ) => {
            tempTowItem = Object.assign({}, input, towItem);
            tempTowItem.ndpf = tempTowItem.lotadpf;
            tempTowItem.stdthick = tempTowItem.stdpwth;
            tempTowItem.tipcirc = circ;
            calculations.slopeAndIntercept(tempTowItem);
            calculations.yieldPredictionModel(tempTowItem);
            calculations.rangeExtension(tempTowItem);
            final.push(tempTowItem);
        });
        let finalData = this.prepareData(final);
        this.renderChart(finalData);
        this.setState({
            rows: finalData,
            item: finalData.length ? finalData[0].item : '',
            lot: finalData.length ? finalData[0].lot : '',
            selectedRowKeys: this.circumferences
        });
    }

    /**
     * onLoadItemsClick function calles doTowItemCalculation function 
     *
     * @param {*} e
     * @memberof TowItemSelectionForm
     */
    onLoadItemsClick = (e) => {
        e.preventDefault();

        let lotNumber = this.state.lotNumberVal;
        let towItem = this.findTowItem(lotNumber);
        
        if (!towItem) {
            message.error(utils.getTranslationText('msg_cannot_find_tow_item', "Cannot find the tow item '${lotNumber}' in our database").replace('${lotNumber}', lotNumber));
            return;
        }

        this.renderTowItemsByCircumference(towItem);
    }
    /**
     *assignData function is for getting the tow items data from redux/store
     *
     * @memberof TowItemSelectionForm
     */
    assignData = (nextProps) => {
        if (nextProps.itemData) {
            this.setState({ towItems: nextProps.itemData }, function () {
                if (this.props.towItemProps && parseFloat(this.props.towItemProps.length) > 0) {
                    this.onLoadItemsClick();
                }
            });
        }
    }

    render() {

        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        }
        return ( 
            <Fragment>
                <div className="view-heading">
                    <h2 className="text-semibold margin-none"><Translation labelName="title_admin_modal_analyzer" defaultText="Model Analyzer"/></h2>
                    {/* <a href='/help/html/Tow_Item_Selection.htm' target="_blank" title="Help" className="help-section">
                        <img
                            src="./images/help-inverse-black.svg"
                            alt="help"
                            className="help-icon" />
                    </a> */}
                </div>
                <div className="cmp-model-analyzer">
                    
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-2">                                
                                <div className="model-properties-container">
                                <h3><Translation labelName="title_model_properties" defaultText="Model Properties"/></h3>
                                <form onSubmit={(e) => this.onLoadItemsClick(e)} noValidate>
                                    <InputField
                                        type="number"
                                        label={<Translation labelName="lbl_length" defaultText="Length"/>}
                                        name="length"
                                        units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm"/>)</Fragment>}
                                        min='0'
                                        value={this.state.length}
                                        id="length"
                                        onChange={(e) => this.handleChange(e)}
                                        className="properties__form-field"
                                    />
                                    <InputField
                                        type="number"
                                        label={<Translation labelName="lbl_plugwrap_thickness" defaultText="Plugwrap Thickness"/>}
                                        id="plugwrapThicknessVal"
                                        units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm"/>)</Fragment>}
                                        min='0'
                                        buttonIcon="setting"
                                        allowedZero={true}
                                        onButtonClick={this.showPlugwrapModal}
                                        name="plugwrapThicknessVal"
                                        className="properties__form-field plugwrap"
                                        value={this.state.plugwrapThicknessVal}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                    <InputField
                                        type="number"
                                        label={<Translation labelName="lbl_lot_number" defaultText="Lot Number"/>}
                                        id="lotNumberVal"
                                        min='0'
                                        allowedZero={true}
                                        name="lotNumberVal"
                                        className="properties__form-field"
                                        value={this.state.lotNumberVal}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                    <Button type="primary"
                                        disabled={!(parseFloat(this.state.length) && this.state.plugwrapThicknessVal && this.state.lotNumberVal)}
                                        htmlType="submit"
                                        className="calculate-link"
                                        onClick={(e) => this.onLoadItemsClick(e)}><Translation labelName="btn_load_items" defaultText="Load Items"/> </Button>
                                    </form>
                                </div>
                                <img
                                    width="100%"
                                    src="./images/model-analyzer.png"
                                    alt="Model Analyzer"
                                    className="model-img" />
                                <ul>
                                    <li>
                                        <span className="std-color"></span>
                                        <span><Translation labelName="tbl_hdr_standard" defaultText="Standard"/></span>
                                    </li>
                                    <li>
                                        <span className="filter-color"></span>
                                        <span><Translation labelName="lbl_filtered_out" defaultText="Filtered Out"/></span>
                                    </li>
                                </ul>
                                </div>
                                <div className="col-sm-5">
                                {this.state.rows ?
                                    <div>
                                    <h4><Translation labelName="lbl_showing" defaultText="Showing" />: {this.state.item} <Translation labelName="tbl_hdr_lot" defaultText="Lot" /> {this.state.lot}</h4>
                                    <Table 
                                        ref={this.myRef}
                                        className={'tow-items-table'}
                                        rowSelection={rowSelection}
                                        rowKey="itmcirc"
                                        rowClassName={
                                            (record) => {
                                                let clsName = [];
                                                if (
                                                    (record.nomtd < 20000 && record.itmcirc > 21) ||
                                                    (record.nomtd > 30000 && record.itmcirc < 19)                                                
                                                ) {
                                                    clsName.push('shade');
                                                }
                                                if(record.itmcirc === record.stdcirc) {
                                                    clsName.push('default');
                                                }
                                                return clsName.join('');
                                            }
                                        }
                                        columns={this.columns}
                                        dataSource={this.state.rows}
                                        size="small"
                                        bordered
                                        pagination={false}
                                    />
                                </div>
                                : ''}
                            </div>
                            <div className="col-md-5">
                            {this.state.rows ?
                                <CustomModelGraph
                                    title={this.state.chartTitle}
                                    isCarbon={false}
                                    lines={this.state.lines}
                                    langSwitch={this.state.langSwitch}
                                    size={{ height: 470, width: 500 }} axis={{
                                        x: {
                                            min: this.state.gminwt,
                                            max: this.state.gmaxwt,
                                            name: utils.getTranslationText('lbl_hdr_weight', 'Weight')
                                        },
                                        y: {
                                            min: this.state.gminpd,
                                            max: this.state.gmaxpd,
                                            name: utils.getTranslationText('lbl_pressure_drop', 'Pressure Drop')
                                        }
                                    }}
                                />   
                            :''}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.visibleplugwrap && <Modal
                    visible={this.state.visibleplugwrap}
                    footer={null}
                    width="1200px"
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        rowSelectionDisable={true}
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}>
                    </PlugwrapThickness>
                </Modal>}
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    onTowItemsSelected: (data) => dispatch(loadTowItems(data))
});

const mapStateToProps = ({ loggedUserState, towItemsState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    userRole: loggedUserState.userRole,
    itemData: towItemsState.itemData
});

export default connect(mapStateToProps, mapDispatchToProps)(ModelAnalyzer);

ModelAnalyzer.propTypes = {
    userRole: PropTypes.string,
    itemData: PropTypes.array,
    onTowItemsSelected: PropTypes.func,
    preferences: PropTypes.object,
    towItemProps: PropTypes.object,
    towItemSelect: PropTypes.func,
    isPropsData: PropTypes.bool,
    handleTowItemSelectionCancel: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/containers/ModelAnalyzer/index.js